import AdminClient from '../client/AdminClient';
import {mapIds} from "../../../helpers/utils";
import _ from "lodash";

class GlobalSearchService {
    static async fetchGlobalSearchInitialData(session) {
        const recentResultsReq = AdminClient.get('/v1/admin/users/recent_result_viewed', session);
        const teammatesReq = AdminClient.get('/v1/admin/teams/teammates', session);
        const [recentResults, teammates] = [await recentResultsReq, await teammatesReq];

        return {
            recentResults: recentResults.data,
            teammates
        }
    }

    static async fetchGlobalSearchAll(session, params) {
        // const listsReq = GlobalSearchService.fetchGlobalSearchLists(session, params);
        const investorsReq = GlobalSearchService.fetchGlobalSearchInvestors(session, params);
        const investorDraftsReq = GlobalSearchService.fetchGlobalSearchInvestorDrafts(session, params);
        // const fundedCompaniesReq = GlobalSearchService.fetchGlobalSearchFundedCompanies(session, params);
        const prevContactsReq = GlobalSearchService.fetchGlobalSearchPrevContacts(session, params);
        const contactsReq = GlobalSearchService.fetchGlobalSearchContacts(session, params);
        const contactDraftsReq = GlobalSearchService.fetchGlobalSearchContactDrafts(session, params);
        const riaEntitiesReq = GlobalSearchService.fetchGlobalSearchRiaEntities(session, params);
        const riaRepsReq = GlobalSearchService.fetchGlobalSearchRiaReps(session, params);
        const usersReq = GlobalSearchService.fetchGlobalSearchUsers(session, params);
        const teamsReq = GlobalSearchService.fetchGlobalSearchTeams(session, params);
        const pwtsReq = GlobalSearchService.fetchGlobalSearchPwts(session, params);
        const foundationsReq = GlobalSearchService.fetchGlobalSearchFoundations(session, params);
        const bankTrustsReq = GlobalSearchService.fetchGlobalSearchBankTrusts(session, params);
        const btContactsReq = GlobalSearchService.fetchGlobalSearchBtContacts(session, params);
        const adminUsersReq = GlobalSearchService.fetchGlobalSearchAdminUsers(session, params);

        const [
            // lists, fundedCompanies,
            investors, investorDrafts, prevContacts, contacts, contactDrafts, riaEntities, riaReps, users, teams, pwts, foundations, adminUsers, bankTrusts, btContacts
        ] = [
            // await listsReq, await fundedCompaniesReq,
            await investorsReq, await investorDraftsReq, await prevContactsReq,
            await contactsReq, await contactDraftsReq, await riaEntitiesReq, await riaRepsReq,
            await usersReq, await teamsReq, await pwtsReq, await foundationsReq, await adminUsersReq, await bankTrustsReq, await btContactsReq
        ];

        return {
            // lists: lists,
            investors: investors,
            investorDrafts: investorDrafts,
            // fundedCompanies: fundedCompanies,
            prevContacts: prevContacts,
            contacts: contacts,
            contactDrafts: contactDrafts,
            riaEntities: riaEntities,
            riaReps: riaReps,
            users: users,
            teams: teams,
            pwts: pwts,
            foundations: foundations,
            bankTrusts: bankTrusts,
            btContacts: btContacts,
            adminUsers: adminUsers,
        }
    }

    static async fetchGlobalSearchLists(session, params) {
        const lists = await AdminClient.get('/v1/admin/global_search/search_lists', session, params);
        return lists.data
    }

    static async fetchGlobalSearchPrevContacts(session, params) {
        const prevContacts = await AdminClient.get('/v1/admin/global_search/search_previous_contacts', session, params);
        return prevContacts.data
    }

    static async fetchGlobalSearchContacts(session, params) {
        const contacts = await AdminClient.get('/v1/admin/global_search/search_contacts', session, params);
        return contacts.data
    }

    static async fetchGlobalSearchContactDrafts(session, params) {
        const riaEntities = await AdminClient.get('/v1/admin/global_search/search_contact_drafts', session, params);
        return riaEntities.data
    }

    static async fetchGlobalSearchRiaReps(session, params) {
        const riaReps = await AdminClient.get('/v1/admin/global_search/search_ria_reps', session, params);
        return riaReps.data
    }

    static async fetchGlobalSearchRiaEntities(session, params) {
        const riaEntities = await AdminClient.get('/v1/admin/global_search/search_ria_entities', session, params);
        return riaEntities.data
    }

    static async fetchGlobalSearchFundedCompanies(session, params) {
        const riaEntities = await AdminClient.get('/v1/admin/global_search/search_funded_companies', session, params);
        return riaEntities.data
    }

    static async fetchGlobalSearchInvestors(session, params) {
        const riaEntities = await AdminClient.get('/v1/admin/global_search/search_investors', session, params);
        return riaEntities.data
    }

    static async fetchGlobalSearchInvestorDrafts(session, params) {
        const riaEntities = await AdminClient.get('/v1/admin/global_search/search_investor_drafts', session, params);
        return riaEntities.data
    }

    static async fetchGlobalSearchUsers(session, params) {
        const users = await AdminClient.get('/v1/admin/global_search/search_users', session, params);
        return users.data
    }

    static async fetchGlobalSearchTeams(session, params) {
        const teams = await AdminClient.get('/v1/admin/global_search/search_teams', session, params);
        return teams.data
    }

    static async fetchGlobalSearchPwts(session, params) {
        const teams = await AdminClient.get('/v1/admin/global_search/search_private_wealth_teams', session, params);
        return teams.data
    }

    static async fetchGlobalSearchFoundations(session, params) {
        const teams = await AdminClient.get('/v1/admin/global_search/search_foundations', session, params);
        return teams.data
    }

    static async fetchGlobalSearchBankTrusts(session, params) {
        const teams = await AdminClient.get('/v1/admin/global_search/search_bank_trusts', session, params);
        return teams.data
    }

    static async fetchGlobalSearchBtContacts(session, params) {
        const btContacts = await AdminClient.get('/v1/admin/global_search/search_bt_contacts', session, params);
        return btContacts?.data ?? { bt_contacts: [], total_count: 0, status: 'fetched' }
    }

    static async fetchGlobalSearchAdminUsers(session, params) {
        const adminUsers = await AdminClient.get('/v1/admin/global_search/search_admin_users', session, params);
        return adminUsers.data
    }

    static async trackLatestViewedResult(session, params) {
        const riaEntities = await AdminClient.post('/v1/admin/users/track_result_view', session, params);
        return riaEntities.data
    }

    static async filterData(params, session) {
        return AdminClient.get(`/v1/admin/global_search/search_filter_data`, session, params);
    }

    static async investors(query, session, dataType) {
        return this.filterData({entity: 'Investor', query, dataType}, session);
    }

    static async riaInvestors(filter, session) {
        return AdminClient.get(`/v1/admin/ria_investors/filter`, session, {filter});
    }

    static async achievements(filter, session) {
        return AdminClient.get(`/v1/admin/achievements/filter`, session, {filter});
    }

    static async investorDrafts(query, session, amount=50) {
        return this.filterData({entity: 'InvestorDraft', query, amount}, session);
    }

    static async titles(query, session) {
        return this.filterData({entity: 'Title', query}, session);
    }

    static async universities(query, session) {
        return this.filterData({entity: 'University', query}, session);
    }

    static async companies(query, session) {
        return this.filterData({entity: 'Company', query}, session);
    }

    static async responsibilities(query, session, dataset) {
        return this.filterData({entity: 'ContactResponsibility', query, dataset}, session);
    }

    static async servicesProvided(query, session, dataset) {
        return this.filterData({entity: 'ServiceProvided', query, dataset}, session);
    }

    static async researchers(query, session, researcherType="any") {
        return AdminClient.get(`/v1/admin/researchers/search`, session, {query, researcherType});
    }

    static async activeResearchers(query, session, researcherType="any") {
        return AdminClient.get(`/v1/admin/researchers/search`, session, {query, researcherType, only_actives: true});
    }

    static async stages(query, session) {
        return this.filterData({entity: 'ItemStage', query}, session);
    }

    static async btStages(query, session) {
        return this.filterData({entity: 'BankTrustStage', query}, session);
    }

    static async foundationStages(query, session) {
        return this.filterData({entity: 'FoundationStage', query}, session);
    }

    static async familyWealthOrigins(query, session) {
        return this.filterData({entity: 'FamilyWealthOrigin', query}, session);
    }

    static async cities(query, session) {
        return AdminClient.get(`/v1/admin/global_search/search_filter_cities`, session, {query});
    }

    static async riaCities(query, session) {
        return AdminClient.get(`/v1/admin/ria_cities/filter`, session, {query});
    }

    static async riaCountries(query, session) {
        return this.filterData({entity: 'RiaCountry', query}, session);
    }

    static async investorTypes(query, session) {
        return AdminClient.get(`/v1/admin/investor_types/search`, session, {query});
    }

    static async fundedCompanies(query, session) {
        return this.filterData({entity: 'FundedCompany', query}, session);
    }
    static async fundedProperties(query, session) {
        return this.filterData({entity: 'FundedProperty', query}, session);
    }

    static async publishers(query, session) {
        return this.filterData({entity: 'Publisher', query}, session);
    }

    static async hobbies(query, session) {
        return this.filterData({entity: 'Hobby', query}, session);
    }

    static async contacts(query, session) {
        return AdminClient.get(`/v1/admin/ria_contacts/search`, session, {query});
    }

    static async fo_contacts(query, session) {
        return AdminClient.get(`/v1/admin/contacts/search`, session, {query});
    }

    static async ria_investors(query, session, active = null, type = null) {
        return AdminClient.get(`/v1/admin/ria_investors/search`, session, {query, active, type});
    }

    static async riaInvestorsMA(query, session) {
        return AdminClient.get(`/v1/admin/ria_investors/search_ma`, session, {query});
    }

    static async btFirms(query, session, stage = 'published') {
        return AdminClient.get(`/v1/admin/bank_trusts/search`, session, {query, stage});
    }

    static async btFirmsForContactWork(query, session, stage = 'published') {
        return AdminClient.get(`/v1/admin/bank_trusts/search_for_dropdown`, session, {query, stage});
    }


    static async foundationsFirms(query, session, idType="ein_num") {
        return AdminClient.get(`/v1/admin/foundations/search`, session, {query, idType});
    }

    static async pwtServices(query, session) {
        return AdminClient.get(`/v1/admin/private_wealth_team_services/filter`, session, {query});
    }

    static async privateWealthTeams(query, session) {
        return AdminClient.get(`/v1/admin/private_wealth_teams/all_private_wealth_team`, session, {query});
    }

    static async pwtTypes(session) {
        return AdminClient.get(`/v1/admin/private_wealth_teams/pwt_types`, session);
    }

    static async foundations(query, session) {
        return AdminClient.get(`/v1/admin/foundations/search`, session, {query});
    }

    static async efContacts(query, session) {
        return AdminClient.get(`/v1/admin/foundation_contacts/search`, session, {query});
    }

    static async bankTrust(query, session, stage='published') {
        return AdminClient.get(`/v1/admin/bank_trusts/search`, session, {query, stage});
    }

    static async btContact(query, session) {
        return AdminClient.get(`/v1/admin/bt_contacts/search`, session, {query});
    }

    static async btBranchOffices(bankTrustId, query, session) {
        return AdminClient.get(`/v1/admin/bank_trusts/${bankTrustId}/branch_offices`, session, {query});
    }

    static async createBtBranchOffice(bankTrustId, data, session) {
        return AdminClient.post(`/v1/admin/bank_trusts/${bankTrustId}/create_branch_office`, session, data);
    }

    static async foundationSectors(query, session) {
        return AdminClient.get(`/v1/admin/foundation_sectors/search`, session, {query});
    }

    static async foundationSubSectors(query, session) {
        return AdminClient.get(`/v1/admin/foundation_sub_sectors/search`, session, {query});
    }

    static async foundationAttachments(query, session) {
        return AdminClient.get(`/v1/admin/foundation_attachments/search`, session, {query});
    }

    static async foundationConsultants(query, session) {
        return AdminClient.get(`/v1/admin/foundation_consultants/search`, session, {query});
    }

    static async allFirms(query, session, entityCategory) {
        return AdminClient.get(`/v1/admin/global_search/search_all_firms`, session, {query, entity_category: entityCategory});
    }

    static async maTransactions(query, session) {
        return AdminClient.get(`/v1/admin/ma_transactions/search`, session, {query});
    }

    static async publicDocuments(investorId, session) { 
        return AdminClient.get(`/v1/admin/ria_investors/${investorId}/public_documents`, session);
    }
}

export default GlobalSearchService;